(function () {
  function getGrid() {
    return document.querySelector('ul.product-grid');
  }

  function sortBySKU() {
  const grid = getGrid();
  if (!grid) return;
  const items = Array.from(grid.querySelectorAll(':scope > [data-sku]'));
  if (!items.length) return;
  items.sort((a, b) => {
    // Extract only the digits after the dash e.g. "AC-1519" → 1519
    const numA = parseInt((a.dataset.sku || '').replace(/^[^-]*-/, ''), 10) || 0;
    const numB = parseInt((b.dataset.sku || '').replace(/^[^-]*-/, ''), 10) || 0;
    return numA - numB;
  });
  items.forEach(item => grid.appendChild(item));
}

  function isSkuSortActive() {
    const params = new URLSearchParams(window.location.search);
    const sort = params.get('sort_by');
    // Active when manual is selected or no sort param (default)
    return !sort || sort === 'manual';
  }

  function observeGrid() {
    const grid = getGrid();
    if (!grid) return;

    const observer = new MutationObserver(() => {
      if (!isSkuSortActive()) return;
      observer.disconnect();
      sortBySKU();
      setTimeout(() => observer.observe(grid, { childList: true }), 500);
    });

    observer.observe(grid, { childList: true });
  }

  function init() {
    if (!isSkuSortActive()) return;
    sortBySKU();
    observeGrid();
  }

  document.addEventListener('DOMContentLoaded', () => {
    let attempts = 0;
    const interval = setInterval(() => {
      attempts++;
      const items = document.querySelectorAll('ul.product-grid > [data-sku]');
      if (items.length > 0) {
        clearInterval(interval);
        init();
      }
      if (attempts >= 20) clearInterval(interval);
    }, 300);
  });

  document.addEventListener('results-list:updated', () => {
    if (!isSkuSortActive()) return;
    setTimeout(sortBySKU, 100);
    setTimeout(sortBySKU, 500);
    setTimeout(sortBySKU, 1000);
  });

})();